import { Routes, Route, Navigate, useNavigate } from "react-router-dom";

import APP_ROUTES from "./routeConstants";

import Dashboard from "../pages/Dashboard";
import Layout from "../shared/Layout";
import Player from "../pages/Player";
import Coach from "../pages/Coach";
import Agent from "../pages/Agent";
import Scout from "../pages/Scout";
import Others from "../pages/Others";
import NotFound from "../pages/NotFound";
import ProtectedRoutes from "./ProtectedRoute";
import Network from "../pages/Network";
import GoStar from "../pages/GoStar";
import Explore from "../pages/Explore";
import Search from "../pages/Search";
import CreateEventSteps from "../pages/Events/CreateEventSteps";
import EventCreated from "../pages/Events/EventCreated";
import EventsList from "../pages/Events/EventsList";
import EventDetails from "../pages/Events/EventDetails";
import CreateGroup from "../pages/Entity/Components/Groups/CreateGroup";
import GroupDetails from "../pages/Entity/Components/Groups/GroupDetails";
import MainLoader from "../shared/MainLoader";
import Home from "../pages/Home";
import Login from "../pages/Login";
import Entity from "../pages/Entity";
import ChatContainer from "../pages/Chat";
import CreateEvent from "../pages/Events/CreateEvents";
import InviteParticipants from "../pages/Events/EventDetails/InviteParticipants";
import PaymentOverview from "../pages/Payment/PaymentOverview";
import HowItWorks from "../pages/Payment/CreatePaymentLink/HowItWorks";
import CreatePaymentLink from "../pages/Payment/CreatePaymentLink/CreatePaymentLink/CreatePaymentLink";
import CreatePaymentAccount from "../pages/Payment/CreatePaymentAccount";
import CreatePaymentLinks from "../pages/Payment/PaymentLinks";
import NetworkError from "../pages/NetworkError";
import { useEffect } from "react";
import { setNavigate } from "./routeUtils";
import TestingGroupChat from "../pages/TestingGroupChat/TestingGroupChat";
import PaymentLink from "../pages/PaymentLink/PaymentLink/PaymentLink";
import PaymentSucceed from "../pages/PaymentLink/PaymentSucceed/PaymentSucceed";
import PaymentFailed from "../pages/PaymentLink/PaymentFailed/PaymentFailed";
import { CreatePostPage, EditPostPage, FeedPage } from "../features/Feeds/pages";
import {
  PlayerProfile,
  PlayerFullTrophies,
  AgentProfile,
  ScoutProfile,
  CoachProfile,
  OtherProfile,
  EntityProfile,
  EntityFullAchievements,
  EntityProfileEdit,
  EntityProfileEditBranch,
  PersonaFullTestimonials,
  AllServices,
  AllReviews,
} from "../features/Profiles/pages";
import { CreateEntityGroup, GroupEntityDetails } from "../features/Groups/pages";
import {
  OverviewServices,
  MyServices,
  // ProgramRequestPage,
  ProgramVideoDetailsPage,
  ServiceRequestPage,
  ServicePage,
  ServiceReviewsPage,
  ProgramPage,
  TrendingProvidersPage,
  TrendingServicesPage,
  CreateContractPage,
  CreateServicePage,
} from "../features/GoService/pages";
import ChatPage from "../features/Chat/pages/ChatPage";
import {
  GinoHomePage,
  GinoChatPage,
  GinoResults,
  GinoChatsHistoryListPage,
  GinoChatHistoryPage,
} from "../features/GINO/pages";
import {
  CreateJobPage,
  GoHirePage,
  JobDetailsPage,
  CandidateDetailsPage,
  CandidateGinoFitScorePage,
  CandidateReportPage,
} from "../features/GoHire/pages";
import { PlansOverviewPage, PlansPage } from "../features/Plans/pages";
import EntityProfileBranch from "../features/Profiles/pages/EntityProfileBranch";
import GoStarPage from "../features/Networking/pages/GoStarPage";
import ApplicationLayout from "../features/ApplicationLayout";
import { HomePage } from "../features/Public/pages/HomePage";

const AppRouter = ({ user, isLoading, isTokenLoaded }: { user: any; isLoading: boolean; isTokenLoaded: boolean }) => {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  if (isLoading && !isTokenLoaded) {
    return <MainLoader />;
  }

  return (
    <Routes>
      <Route path={APP_ROUTES.PUBLIC_HOME} element={<HomePage />} />

      <Route path={APP_ROUTES.HOME} element={user ? <Navigate to={APP_ROUTES.DASHBOARD} /> : <Home />} />
      <Route path={APP_ROUTES.LOGIN} element={user ? <Navigate to={APP_ROUTES.DASHBOARD} /> : <Login />} />

      <Route element={<ProtectedRoutes isTokenLoaded={isTokenLoaded} />}>
        {/* <Route element={<Layout />}> */}
        <Route element={<ApplicationLayout />}>
          <Route path={APP_ROUTES.DASHBOARD} element={<Dashboard />} />
          <Route path={APP_ROUTES.NETWORK} element={<Network />} />
          <Route path={APP_ROUTES.EXPLORE} element={<Explore />} />
          {/* <Route path={APP_ROUTES.CREATE_GROUP} element={<CreateGroup />} />
          <Route path={APP_ROUTES.GROUP_DETAILS} element={<GroupDetails />} /> */}
          <Route path="group-chat" element={<TestingGroupChat />} />
          {/* <Route path={APP_ROUTES.ENTITY} element={<Entity />} /> */}
          {/* <Route path={APP_ROUTES.ENTITY_DETAILS} element={<Entity />} /> */}

          {/* Entity */}
          {/* <Route path={APP_ROUTES.ENTITY} element={<EntityProfile />} /> */}
          <Route path={APP_ROUTES.ENTITY_DETAILS} element={<EntityProfile />} />
          <Route path={APP_ROUTES.ENTITY_PROFILE_EDIT} element={<EntityProfileEdit />} />
          <Route path={APP_ROUTES.ENTITY_PROFILE_EDIT_BRANCH} element={<EntityProfileEditBranch />} />
          <Route path={APP_ROUTES.ENTITY_PROFILE_BRANCH} element={<EntityProfileBranch />} />
          <Route path={APP_ROUTES.ENTITY_ACHIEVEMENTS} element={<EntityFullAchievements />} />
          <Route path={APP_ROUTES.ENTITY_GROUP_CREATE} element={<CreateEntityGroup />} />
          <Route path={APP_ROUTES.ENTITY_GROUP_DETAILS} element={<GroupEntityDetails />} />

          {/* <Route path={APP_ROUTES.PLAYER} element={<Player />} />
          <Route path={APP_ROUTES.COACH} element={<Coach />} />
          <Route path={APP_ROUTES.AGENT} element={<Agent />} />
          <Route path={APP_ROUTES.SCOUT} element={<Scout />} />
          <Route path={APP_ROUTES.OTHER_PROFILE} element={<Others />} /> */}

          {/* Profiles */}
          <Route path={APP_ROUTES.PLAYER} element={<PlayerProfile />} />
          <Route path={APP_ROUTES.PLAYER_TROPHIES} element={<PlayerFullTrophies />} />
          <Route path={APP_ROUTES.COACH} element={<CoachProfile />} />
          <Route path={APP_ROUTES.AGENT} element={<AgentProfile />} />
          <Route path={APP_ROUTES.SCOUT} element={<ScoutProfile />} />
          <Route path={APP_ROUTES.OTHER_PROFILE} element={<OtherProfile />} />
          <Route path={APP_ROUTES.PERSONA_TESTIMONIALS} element={<PersonaFullTestimonials />} />

          {/* All Services */}
          <Route path={APP_ROUTES.ALL_SERVICES} element={<AllServices />} />
          <Route path={APP_ROUTES.ALL_REVIEWS} element={<AllReviews />} />

          {/* Go Service */}
          <Route path={APP_ROUTES.OVERVIEW_SERVICES} element={<OverviewServices />} />
          <Route path={APP_ROUTES.SERVICE_PAGE} element={<ServicePage />} />
          <Route path={APP_ROUTES.SERVICE_REVIEW_PAGE} element={<ServiceReviewsPage />} />
          <Route path={APP_ROUTES.MY_SERVICES} element={<MyServices />} />
          <Route path={APP_ROUTES.SERVICE_REQUEST_PAGE} element={<ServiceRequestPage />} />
          {/* <Route path={APP_ROUTES.PROGRAM_REQUEST_PAGE} element={<ProgramRequestPage />} /> */}
          <Route path={APP_ROUTES.PROGRAM_VIDEO_PAGE} element={<ProgramVideoDetailsPage />} />
          <Route path={APP_ROUTES.PROGRAM_PAGE} element={<ProgramPage />} />
          <Route path={APP_ROUTES.TRENDING_SERVICES} element={<TrendingServicesPage />} />
          <Route path={APP_ROUTES.TRENDING_PROVIDERS} element={<TrendingProvidersPage />} />
          <Route path={APP_ROUTES.CREATE_CONTRACT} element={<CreateContractPage />} />
          <Route path={APP_ROUTES.CREATE_SERVICE} element={<CreateServicePage />} />

          {/* Go Star */}
          <Route path={APP_ROUTES.GO_STAR} element={<GoStar />} />
          <Route path={APP_ROUTES.GO_STAR_QUERY} element={<GoStar />} />

          {/* Search */}
          <Route path={APP_ROUTES.SEARCH} element={<Search />} />

          {/* Chat */}
          <Route path={APP_ROUTES.CHAT} element={<ChatPage />} />
          <Route path={APP_ROUTES.CHAT_DETAILS} element={<ChatPage />} />

          {/* Events */}
          <Route path={APP_ROUTES.EVENTS} element={<EventsList />} />
          <Route path={APP_ROUTES.CREATE_EVENT} element={<CreateEvent />} />
          <Route path={APP_ROUTES.CREATE_EVENT_STEPS} element={<CreateEventSteps />} />
          <Route path={APP_ROUTES.EVENT_CREATED} element={<EventCreated />} />
          <Route path={APP_ROUTES.EVENT_DETAILS} element={<EventDetails />} />
          <Route path={APP_ROUTES.INVITE_PARTICIPANTS} element={<InviteParticipants />} />

          {/* Payment */}
          <Route path={APP_ROUTES.PAYMENT} element={<PaymentOverview />} />
          <Route path={APP_ROUTES.PAYMENT_HOW_IT_WORKS} element={<HowItWorks />} />
          <Route path={APP_ROUTES.CREATE_PAYMENT_LINK} element={<CreatePaymentLink />} />
          <Route path={APP_ROUTES.CREATE_PAYMENT_ACCOUNT} element={<CreatePaymentAccount />} />
          <Route path={APP_ROUTES.PAYMENT_LINKS} element={<CreatePaymentLinks />} />

          {/* Feed */}
          <Route path={APP_ROUTES.FEED} element={<FeedPage />} />
          <Route path={APP_ROUTES.CREATE_POST} element={<CreatePostPage />} />
          <Route path={APP_ROUTES.EDIT_POST} element={<EditPostPage />} />

          {/* Revamped profiles */}
          <Route path="/player-new/:userId" element={<PlayerProfile />} />

          {/* GINO */}
          <Route path={APP_ROUTES.GINO} element={<GinoHomePage />} />
          <Route path={APP_ROUTES.GINO_CHAT} element={<GinoChatPage />} />
          <Route path={APP_ROUTES.GINO_SEARCH_RESULTS} element={<GinoResults />} />
          <Route path={APP_ROUTES.GINO_CHAT_HISTORY} element={<GinoChatsHistoryListPage />} />
          <Route path={APP_ROUTES.GINO_CHAT_HISTORY_ROOM} element={<GinoChatHistoryPage />} />

          {/* Go Hire */}
          <Route path={APP_ROUTES.JOBS} element={<GoHirePage />} />
          <Route path={APP_ROUTES.JOB_OVERVIEW} element={<JobDetailsPage />} />
          <Route path={APP_ROUTES.CANDIDATE_DETAILS} element={<CandidateDetailsPage />} />
          <Route path={APP_ROUTES.CANDIDATE_GINO_FIT_SCORE} element={<CandidateGinoFitScorePage />} />
          <Route path={APP_ROUTES.CANDIDATE_REPORT} element={<CandidateReportPage />} />

          <Route path={APP_ROUTES.PLANS} element={<PlansPage />} />
          <Route path={APP_ROUTES.PLANS_OVERVIEW} element={<PlansOverviewPage />} />
        </Route>

        {/* Go Hire */}
        <Route path={APP_ROUTES.CREATE_JOB} element={<CreateJobPage />} />
      </Route>

      <Route path={APP_ROUTES.PAYMENT_LINK} element={<PaymentLink />} />
      <Route path={APP_ROUTES.PAYMENT_LINK_SUCCEED} element={<PaymentSucceed />} />
      <Route path={APP_ROUTES.PAYMENT_LINK_FAILED} element={<PaymentFailed />} />

      <Route path={APP_ROUTES.CATCH} element={<NotFound />} />
      <Route path={APP_ROUTES.NETWORK_ERROR} element={<NetworkError />} />
    </Routes>
  );
};

export default AppRouter;
